import { IAppConfig } from 'portalServices';
import { getServiceConfig } from './service.config';

export function getWebServiceConfig(): IAppConfig
{
    const config = getServiceConfig();
    return {
        apiEndpoint: config?.apiEndpoint || '',
        domainName: config?.domainName || '',
        ...config
    };
}
